
































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { CouponsService } from "@/services/Coupons.service.ts";
import Number from "@/shared/filters/Number";
import { CouponItem } from "@/models/Coupon.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import { CommonService } from "@/services/Common.service";
import DialogMasterCopy from "./components/DialogMasterCopy.vue";
import ComponentWithGroupShaten from '@/views/components/ComponentWithGroupShaten';
import FilterSelectBox from '@/shared/mixins/FilterSelectBox';

/** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
import { SeibiService } from "@/services/Seibi.service";
/** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
export interface CouponDataTb extends CouponItem {
  isEdit?: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable,
    DialogMasterCopy
  },
  mixins: [FilterSelectBox]
})
export default class CouponDetail extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  selectedTaxRate: number | null = null;
  public couponService = new CouponsService();
  public commonService = new CommonService();
  public couponData: CouponItem = {
    kyotenCd: "",
    couponNm: "",
    couponZn: null,
    couponZk: null
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
    , shuukeiKbn: null
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
  };
  public couponEdit: CouponItem = {
    id: 0,
    kyotenCd: "",
    couponNm: "",
    couponZn: null,
    couponZk: null
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
    , shuukeiKbn: null
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
  };
  public couponList: CouponDataTb[] = [];
  public couponItemList: CouponDataTb[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;
  public dialogFormVisible: boolean = false;
  maxCoupon: number = 15;
  disableBtnAdd: boolean = true;
  disableBtnEdit: boolean = true;
  timerReOrder: any = null;
  taxList: any = [];
  couponLimit: number = 0;
  showDialogLimit: boolean = false;
  limitZn: any = null;
  limitZk: any = null;
  isExistLimit: boolean = false;
  couponLimitItem: any = null;
  loadingLimit: boolean = true;

  $refs!: {
    dialogCopy: DialogMasterCopy;
    inputZk: InputNumber;
  };

  shouhizeiMarumeKbn: number = 0;
  environment: any;

  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
  public seibiService = new SeibiService();
  shuukeiDataList: any = [];
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */

  constructor() {
    super();
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.couponData.couponNm && this.couponData.couponZn) {
      this.loading = true;
      const data = {
        ...this.couponData,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd
      };
      /** 2023-07-28 sh #8295(BQR1045) ommit shuukeiKbn. (temporary) [START] */
      delete data.shuukeiKbn;
      /** 2023-07-28 sh #8295(BQR1045) ommit shuukeiKbn. (temporary) [END] */
      this.addCouponItem({ ...data });
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
      this.clearInput();
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    }
  }

  public async getTaxList() {
    const response = await this.commonService.getTaxList();
    if (response) {
      this.$set(this, "taxList", response);
      const tempTax: any = this.taxList.filter(
        (data: any) => data.isCurrent == 1
      );
      if (tempTax.length !== 0) {
        this.selectedTaxRate = tempTax[0].rateExtremeType;
      }
    }
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.kyotenCd === this.form.kyotenCd
    );
    this.getCouponList();
    this.getCouponLimit();
    this.delay(1000);
  }

  public async getCouponList(id?: number) {
    this.loading = true;
    const response = await this.couponService.getCoupons(this.form, id);
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "couponList", [...data]);
    } else {
      this.$set(this, "couponList", []);
    }
    this.loading = false;
    this.checkDisabledAdd();
  }

  public async addCouponItem(data: CouponItem) {
    const response = await this.couponService.editCoupons(data);
    if (response) {
      this.getCouponList();
      this.delay(1000);
    } else {
      this.delay(1000);
    }
  }

  public async delCouponItem(id: number) {
    this.loading = true;
    const response = await this.couponService.deleteCoupons(id);
    if (response) {
      this.getCouponList();
      this.delay(1000);
    } else {
      this.delay(1000);
    }
  }

  public async saveCouponList(data: any) {
    const response = await this.couponService.saveCoupons(data, this.form);
    if (response) {
      console.log(response);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.couponEdit = { ...rowData };
    this.checkDisabledEdit();
  }

  public editCouponItem() {
    this.loading = true;
    if (
      this.couponEdit.id &&
      this.couponEdit.couponNm &&
      this.couponEdit.couponZn
    ) {
      const data = {
        id: this.couponEdit.id,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd,
        couponNm: this.couponEdit.couponNm,
        couponZn: this.couponEdit.couponZn,
        couponZk: this.couponEdit.couponZk
        /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
        , shuukeiKbn: this.couponEdit.shuukeiKbn
        /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
      };
      this.addCouponItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private mounted() {
    this.getTaxList();
    this.form.kyotenCd = localStorage.getItem("kyotenCd");

    this.getGroupDataList().then(res => {
      this.getCouponLimit();
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          this.getCouponList();
          /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
          this.getMExpSeibiShuukeiKbn();
          /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
        });
      });
    });
    this.getMarumeKbn();
  }

  async getMarumeKbn() {
    this.environment = await this.commonService.getEnvironment();
    if (this.environment) {
      this.shouhizeiMarumeKbn = this.environment.shouhizeiMarumeKbn;
    }
  }

  convertMinus(key: string, isEdit: boolean) {
    let couponData: CouponItem = this.getCouponItem(isEdit);
    if (couponData[key] > 0) {
      couponData[key] *= -1;
      this.$set(couponData, key, couponData[key]);
    }
  }

  getCouponItem(isEdit: boolean) {
    let couponData: CouponItem;
    if (isEdit) {
      couponData = this.couponEdit;
    } else {
      couponData = this.couponData;
    }
    return couponData;
  }

  focusOutZn(isEdit: boolean) {
    this.focusOutPrice(isEdit, false);
  }

  focusOutZk(isEdit: boolean) {
    this.focusOutPrice(isEdit, true);
  }

  async focusOutPrice(isEdit: boolean, isZk: boolean) {
    let couponData: CouponItem = this.getCouponItem(isEdit);
    if (isEdit) {
      this.checkDisabledEdit();
    } else {
      this.checkDisabledAdd();
    }
    if (isZk) {
      if (couponData.couponZk) {
        this.convertMinus("couponZk", isEdit);
        let zn = await this.commonService.calcZeinuki(
          couponData.couponZk,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(couponData, "couponZn", zn);
      } else {
        this.$set(couponData, "couponZn", 0);
      }
    } else {
      if (couponData.couponZn) {
        this.convertMinus("couponZn", isEdit);
        let zk = await this.commonService.calcZeikomi(
          couponData.couponZn,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(couponData, "couponZk", zk);
      } else {
        this.$set(couponData, "couponZk", 0);
      }
    }
  }

  checkDisabledAdd() {
    setTimeout(() => {
      let disabled = false;
      /** 2020-11-12 del validate [START] */
      // if (this.couponList.length >= this.maxCoupon) {
      //   disabled = true;
      // } else if (
      /** 2020-11-12 del validate [END] */
      if (
        this.couponData.couponNm === "" ||
        this.couponData.couponZn === null
      ) {
        disabled = true;
      }
      this.$set(this, "disableBtnAdd", disabled);
    }, 300);
  }

  checkDisabledEdit() {
    let disabled = false;
    if (this.couponEdit.couponNm === "" || this.couponEdit.couponZn === null) {
      disabled = true;
    }
    this.$set(this, "disableBtnEdit", disabled);
  }

  onEnd(event: any) {
    console.log("onEnd -> event", this.couponList);
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      const data = this.couponList.map((e: any) => {
        let item = { ...e };
        delete item.isEdit;
        return item;
      });
      this.saveCouponList(data);
    }, 1000);
  }

  clearInput() {
    this.couponData.couponNm = "";
    this.couponData.couponZk = null;
    this.couponData.couponZn = null;
    this.checkDisabledAdd();
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
    this.couponData.shuukeiKbn = null;
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
  }

  async onChangeTaxRate() {
    if (this.couponData.couponZn) {
      let zk = await this.commonService.calcZeikomi(
        this.couponData.couponZn,
        this.selectedTaxRate
      );
      this.$set(this.couponData, "couponZk", zk);
    }
  }

  onOpenMasterCopy() {
    this.$refs.dialogCopy.open();
  }

  onEnterZk() {
    this.$refs.inputZk.blur();
  }

  async onChangeLimit(isZk: boolean) {
    let price = 0;
    let key = isZk ? "limitZn" : "limitZk";
    if (isZk) {
      if (this.limitZk) {
        price = await this.commonService.calcZeinuki(
          this.limitZk,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
      }
    } else {
      if (this.limitZn) {
        price = await this.commonService.calcZeikomi(
          this.limitZn,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
      }
    }
    this.$set(this, key, price);
  }

  getKyotenNm(kyotenCd: string) {
    if (kyotenCd) {
      const kyoten = this.kyotenDataList.find(
        (e: any) => e.kyotenCd === kyotenCd
      );
      if (kyoten) {
        return `${kyoten.kyotenNm}(${kyotenCd})`;
      }
    }
    return "";
  }

  getShatenNm(shatenCd: string) {
    if (shatenCd) {
      const shaten = this.shatenDataList.find(
        (e: any) => e.shatenCd === shatenCd
      );
      if (shaten) {
        return `${shaten.kaishaNm}(${shatenCd})`;
      }
    }
    return "";
  }

  onOpenDialogLimit() {
    if (this.couponLimitItem) {
      this.limitZk = this.couponLimitItem.couponLimitZk;
      this.limitZn = this.couponLimitItem.couponLimitZn;
    } else {
      this.limitZk = 0;
      this.limitZn = 0;
    }
  }

  onSaveLimit() {
    const data = {
      ...this.form,
      couponLimitZk: this.limitZk,
      couponLimitZn: this.limitZn
    };
    let process;
    if (this.isExistLimit) {
      data.id = this.couponLimitItem.id;
      process = this.couponService.updateCouponLimit(data);
    } else {
      process = this.couponService.saveCouponLimit(data);
    }
    process.then(
      (res: any) => {
        this.getCouponLimit();
      },
      err => {
        this.$message.error("エラー");
      }
    );

    this.showDialogLimit = false;
  }

  async getCouponLimit() {
    this.loadingLimit = true;
    const { result, error } = await this.couponService.getCouponLimit(
      this.form
    );
    if (result && result.data) {
      this.isExistLimit = true;
      this.couponLimitItem = result.data;
      this.couponLimit = this.couponLimitItem.couponLimitZn;
    } else {
      this.isExistLimit = false;
      this.couponLimit = 0;
      this.couponLimitItem = null;
    }
    this.loadingLimit = false;
  }

  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
  async getMExpSeibiShuukeiKbn() {
    const res = await this.seibiService.getMExpSeibiShuukeiKbn();
    if (res) {
      this.shuukeiDataList = res;
    } else {
      this.shuukeiDataList = [];
    }
  }

  getShuukeiKbnLabel(item: any) {
    const tempShuukei: any = this.shuukeiDataList.filter(
      (data: any) => item.shuukeiKbn != null && data.shuukeiKbn == item.shuukeiKbn
    );
    if (tempShuukei.length !== 0 && tempShuukei.length > 0) {
      return tempShuukei[0].shuukeiKbnNm;
    }

    return '';
  }
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
}
